import { useQuery } from '@tanstack/react-query'
import { PlusIcon } from 'lucide-react'
import { Button, ButtonProps } from '../../../components'
import { useCogfy } from '../../../hooks'

export function AddGoogleDriveButton (props: ButtonProps) {
  const cogfy = useCogfy()

  const data = {
    provider: 'googleDrive' as const
  }
  const getGoogleDriveAuthUrl = useQuery({
    queryKey: ['getGoogleAuthUrl', data],
    queryFn: ({ signal }) => cogfy.getGoogleAuthUrl(data, { signal })
  })

  return (
    <Button
      color={props.color}
      size={props.size || 'sm'}
      disabled={getGoogleDriveAuthUrl.isLoading}
      to={getGoogleDriveAuthUrl.data?.authUrl}
      className={props.className}
    >
      <PlusIcon size={16} />
      {props.children}
    </Button>
  )
}
